import {FaCertificate, FaTrophy} from "react-icons/fa6";
import API, {HandleError} from "../API";
import {Category} from "../models/Category";
import {useContext, useEffect, useState} from "react";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";
import {Alert} from "react-bootstrap";
import {PiLightningBold} from "react-icons/pi";
import {Trans} from "react-i18next/icu.macro";
import {useTranslation} from "react-i18next";

export default function Leaderboard() {
    const { enqueueSnackbar } = useSnackbar()
    const { t, i18n } = useTranslation();
    const app = useContext(AppContext)
    const [board, setBoard] = useState([])
    const [boardLoaded, setBoardLoaded] = useState(false)

    useEffect(() => {
        getLeaderboard()

    }, [app.user.current_course])
    const getLeaderboard = async () => {
        try {
            const res = await API({
                method: 'GET',
                url: `/leaderboard`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {}
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            setBoard([...res.data.results])
            setBoardLoaded(true)
        }
        catch(e) {
            setBoardLoaded(true)
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }
    return <div className="dashboard-widget widget-leaderboard">
        <h3 className="widget-title">{t('leaderboard.title')}</h3>
        <div className="widget-body">
            <div className="mb-3 text-muted">
                <small>
                    <Trans i18nKey="leaderboard.subtitle" />
                </small>
            </div>
            <ul className="leaderboard-list">
                {board.length > 0 && board.map((item, idx) => {
                    let classes = []
                    if(item.ID == app.user.ID)
                        classes.push('me')
                    if(item.position === 1)
                        classes.push('first')
                    if(item.position === 2)
                        classes.push('second')
                    if(item.position === 3)
                        classes.push('third')

                    return <li className={classes.join(' ')} key={'leaderboard-'+idx}>
                        <span className="position">{item.position === 1 ? <FaTrophy /> : (item.position <= 3 ? <FaCertificate /> : '')}
                            <span>{item.position > 20 ? '20+' : item.position}</span>
                        </span>
                        <span className="name">{item.name}</span>
                        <span className="points">{item.score} Pts.</span>
                    </li>
                })}
                {boardLoaded && board.length <= 0 && <li>
                    <Alert variant="info" style={{fontSize: 14}}>
                        <Alert.Heading style={{fontSize: 20}}><PiLightningBold /> {t('leaderboard.error.title')}</Alert.Heading>
                        <Trans i18nKey="leaderboard.error.text" />
                    </Alert>
                </li>}
            </ul>
        </div>
    </div>
}